import { defineAsyncComponent } from 'vue';
import { AbstractModalService } from '@/core/modals/AbstractModalService';
import { ModalOptions } from '@/core/modals/ModalState';
import { WebInquiryBlockViewModel } from '@/types/contentServerContract';

export interface WebInquirySubscribeOverlayOption {
    webInquiryName: string;
    businessLines: string[];
    brand: string;
    isPrivateLabel: boolean;
}

class WebInquirySubscribeOverlayService extends AbstractModalService {
    public show(webInquiryFeedbackSettings: WebInquiryBlockViewModel, options?: Partial<ModalOptions>) {
        return this.showModal({
            component: defineAsyncComponent(() => import('@/project/app/blocks/webinquiries/WebInquirySubscribeOverlay.vue')),
            componentAttrs: {
                content: {
                    heading: webInquiryFeedbackSettings.header,
                    bodyText: webInquiryFeedbackSettings.subheader,
                    commentInputHeader: webInquiryFeedbackSettings.commentInputHeader,
                    commentInputPlaceholderText: webInquiryFeedbackSettings.commentInputPlaceholderText,
                    contactConfirmationText: webInquiryFeedbackSettings.contactConfirmationText,
                    ctaText: webInquiryFeedbackSettings.ctaText,
                    ctaColor: webInquiryFeedbackSettings.ctaColor,
                    showCommentInput: webInquiryFeedbackSettings.allowComment,
                    successHeading: webInquiryFeedbackSettings.receiptHeader,
                    successBodyText: webInquiryFeedbackSettings.receiptBodyText,
                    instructions: webInquiryFeedbackSettings.instructions,
                    webInquiryOption: {
                        webInquiryName: webInquiryFeedbackSettings.webInquiryName,
                        businessLines: webInquiryFeedbackSettings.businessLines,
                        brand: webInquiryFeedbackSettings.brand || '',
                        isPrivateLabel: webInquiryFeedbackSettings.privateLabel
                    }
                }
            },
            options: {
                showCloseButton: true,
                closeOnRouteChange: true,
                ...options
            }
        });
    }
}

export default new WebInquirySubscribeOverlayService();
